'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings');
    };
  };
};

exports.default = createGetFormSyncWarnings;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormSyncWarnings.js
// module id = 1053
// module chunks = 0